export default __webpack_public_path__ + "static/media/inner-tech-augmented-workforce.103371a8.svg";